import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = {
  key: 0,
  class: "mb-1 flex flex-row items-center"
}
const _hoisted_3 = { class: "text-left font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_5 = { class: "px-1 py-1" }
const _hoisted_6 = {
  key: 1,
  class: "mb-1 flex flex-row items-center"
}
const _hoisted_7 = { class: "text-left font-semibold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_9 = { class: "px-1 py-1" }
const _hoisted_10 = { class: "onboarding-card space-y-2" }
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = { class: "p-1 pl-2 w-1/2 text-left" }
const _hoisted_13 = { class: "p-1 pr-2 w-1/2 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DotsVerticalIcon = _resolveComponent("DotsVerticalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_EmotionInsightMessagesModal = _resolveComponent("EmotionInsightMessagesModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.team && !_ctx.hideTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: { name: 'teams.details', params: { id: _ctx.team.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.team.name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_4,
            (_ctx.canDelete == true)
              ? (_openBlock(), _createBlock(_component_Menu, {
                  key: 0,
                  as: "div",
                  class: "relative inline-block text-left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_MenuButton, { class: "inline-flex justify-center w-full p-2 text-sm font-medium text-black bg-teal rounded-md bg-opacity-0 hover:bg-opacity-30" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DotsVerticalIcon, {
                            class: "w-5 h-5 text-black",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition duration-100 ease-out",
                      "enter-from-class": "transform scale-95 opacity-0",
                      "enter-to-class": "transform scale-100 opacity-100",
                      "leave-active-class": "transition duration-75 ease-in",
                      "leave-from-class": "transform scale-100 opacity-100",
                      "leave-to-class": "transform scale-95 opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuItems, { class: "absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none z-20" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_MenuItem, null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([
            active ? 'bg-red-600 text-white' : 'text-red-600',
            'group flex rounded-md items-center w-full px-2 py-2 text-sm',
        ]),
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteClicked && _ctx.deleteClicked(...args)))
                                  }, [
                                    _createVNode(_component_TrashIcon, {
                                      active: active,
                                      class: "w-5 h-5 mr-2 text-red-600",
                                      "aria-hidden": "true"
                                    }, null, 8, ["active"]),
                                    _createTextVNode(" Delete Team ")
                                  ], 2)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.channel && !_ctx.hideTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, "#" + _toDisplayString(_ctx.channel.name), 1),
            _hoisted_8,
            (_ctx.canDelete == true)
              ? (_openBlock(), _createBlock(_component_Menu, {
                  key: 0,
                  as: "div",
                  class: "relative inline-block text-left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_MenuButton, { class: "inline-flex justify-center w-full p-2 text-sm font-medium text-black bg-teal rounded-md bg-opacity-0 hover:bg-opacity-30" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DotsVerticalIcon, {
                            class: "w-5 h-5 text-black",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition duration-100 ease-out",
                      "enter-from-class": "transform scale-95 opacity-0",
                      "enter-to-class": "transform scale-100 opacity-100",
                      "leave-active-class": "transition duration-75 ease-in",
                      "leave-from-class": "transform scale-100 opacity-100",
                      "leave-to-class": "transform scale-95 opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuItems, { class: "absolute right-0 w-56 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none z-20" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_MenuItem, null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([
            active ? 'bg-red-600 text-white' : 'text-red-600',
            'group flex rounded-md items-center w-full px-2 py-2 text-sm',
        ]),
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteClicked && _ctx.deleteClicked(...args)))
                                  }, [
                                    _createVNode(_component_TrashIcon, {
                                      active: active,
                                      class: "w-5 h-5 mr-2 text-red-600",
                                      "aria-hidden": "true"
                                    }, null, 8, ["active"]),
                                    _createTextVNode(" Delete Channel ")
                                  ], 2)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scores, (score) => {
          return (_openBlock(), _createElementBlock("div", {
            title: `Inspect ${score.title}`,
            key: score.title,
            class: "flex relative z-10 cursor-pointer",
            onClick: () => _ctx.inspectEmotion(score.name, score.title)
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["absolute h-full rounded -z-10", score.colorClass]),
              style: _normalizeStyle({ width: score.percentage, backgroundColor: score.colorClass })
            }, null, 6),
            _createElementVNode("p", _hoisted_12, _toDisplayString(score.title), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(score.percentage), 1)
          ], 8, _hoisted_11))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.showEmotionInsightsMessages)
        ? (_openBlock(), _createBlock(_component_EmotionInsightMessagesModal, {
            key: 0,
            messages: _ctx.emotionInsightMessages,
            loading: _ctx.loadingEmotionInsightsMessages,
            emotion: _ctx.selectedEmotion as string,
            errorMessage: _ctx.errorMessage as string,
            onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEmotionInsightsMessages = false))
          }, null, 8, ["messages", "loading", "emotion", "errorMessage"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}